import styled from '@emotion/styled';
import Container from '@ep/components/Container';
import { H2Medium, H4, Subhead2 } from '@ep/components/Typography';
import { Body, H2, H3, Label } from '@ep/templates/ProductPage';
import theme from '@ep/theme';
import React, { useEffect, useState } from 'react';

interface SavingsToolItem {
  label: string;
  savings: string;
  PO: string;
  hours: string;
}

interface SavingsToolProps {
  savingsToolData: SavingsToolItem[];
  savingsDisclaimer?: string;
}

const Savings = styled.div`
  margin-top: 2rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  color: ${theme.colors.oceanBlue};
  h2 {
    font-family: ${theme.typography.primaryFont.light};
    margin-top: 2rem;
    margin-bottom: 0.5rem;
    color: ${theme.colors.oceanBlue};
  }
  ${theme.mediaQueries.mobileAndTablet} {
    text-align: center;
  }
`;

const SubSavingsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  ${theme.mediaQueries.mobileAndTablet} {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

const SubSavings = styled.div`
  margin-top: 1rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  color: ${theme.colors.duskBlue};
  font-weight: bold;
  h2 {
    font-family: ${theme.typography.primaryFont.light};
    margin-bottom: 0.5rem;
    color: ${theme.colors.duskBlue};
  }
`;

const SavingsSelection = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 2rem 0;
  ${theme.mediaQueries.mobileAndTablet} {
    flex-direction: column;
  }
`;

const CircleButton = styled.button`
  background-color: ${theme.colors.white};
  border: solid 2px ${theme.colors.mantisGreen};
  border-radius: 50%;
  height: 2rem;
  width: 2rem;
  cursor: pointer;
  margin: 0.5rem auto;
  :hover {
    background-color: ${theme.colors.mantisGreen};
  }
`;

const SavingsItem = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  color: ${props =>
    props.active ? theme.colors.oceanBlue : theme.colors.darkGray};
  button {
    background-color: ${props =>
      props.active ? theme.colors.mantisGreen : theme.colors.white};
  }
`;

const SavingsDisclaimerContainer = styled.p`
  text-align: center;
  margin-top: 2rem;
  padding: 0 30% 0% 30%;
  @media (max-width: ${theme.breakpoints.optimalMobile + 950}px) {
  }
  @media (max-width: ${theme.breakpoints.optimalMobile + 700}px) {
    margin: auto auto;
    margin-top: 2rem;
  }
  ${theme.mediaQueries.mobile} {
    width: 83%;
    margin-top: 2rem;
    padding: 0 10% 0% 10%;
  }
`;

const SavingsToolModule = ({
  savingsToolData,
  savingsDisclaimer,
}: SavingsToolProps) => {
  const percentage = 100;

  const [selectedOnce, setSelectedOnce] = useState(false);
  const [selection, setSelection] = useState(0);
  const [value, setValue] = useState(0);

  const updatePercentage = () => {
    setTimeout(() => {
      setValue(value + 5);
    }, 10);
  };

  useEffect(() => {
    if (value < percentage) updatePercentage();
  }, [value]);

  const handleSelect = (index: number) => {
    if (selectedOnce === false) {
      // dataLayer.push({ event: 'Interactive Tool – user engaged' }); 
      setSelectedOnce(true);
    } else {
    }
    setSelection(index);
    setValue(0);
  };

  const convertNumbers = (number: string) => {
    const tempNum = parseInt(number);
  };

  return (
    <Container>
      <Savings>
        <H2Medium>
          {`$${Math.round(
            parseInt(savingsToolData[selection].savings) * (value / 100),
          ).toLocaleString()}`}
        </H2Medium>
        <Body>Potential Cost Savings</Body>
      </Savings>
      <SubSavingsContainer>
        <SubSavings>
          <H2Medium>
            {`${Math.round(
              parseInt(savingsToolData[selection].PO) * (value / 100),
            ).toLocaleString()}`}
          </H2Medium>
          <Body>Average Number of POs</Body>
        </SubSavings>
        <SubSavings>
          <H2Medium>
            {`${Math.round(
              parseInt(savingsToolData[selection].hours) * (value / 100),
            ).toLocaleString()}`}
          </H2Medium>
          <Body>Average Time Savings in Hours</Body>
        </SubSavings>
      </SubSavingsContainer>

      <SavingsSelection>
        {savingsToolData.map((item, index) => (
          <SavingsItem key={item.label} active={selection === index}>
            <Body>{item.label}</Body>
            <CircleButton onClick={() => handleSelect(index)} />
          </SavingsItem>
        ))}
      </SavingsSelection>
      {savingsDisclaimer && (
        <Body>
          <SavingsDisclaimerContainer>
            {savingsDisclaimer}
          </SavingsDisclaimerContainer>
        </Body>
      )}
    </Container>
  );
};

export default React.memo(SavingsToolModule);
